webpackJsonp([2,11],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(13)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(11),
	  /* template */
	  __webpack_require__(15),
	  /* scopeId */
	  "data-v-23a5876e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 11:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    props: ['title', 'marginTop', 'noPadding'],
	    computed: {
	        contentMarginTop: function contentMarginTop() {
	            if (this.marginTop) {
	                return this.marginTop;
	            } else {
	                return 0;
	            }
	        }
	    }
	};

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".blank[data-v-23a5876e]{visibility:hidden;height:0}.content-item[data-v-23a5876e]{width:1080px;min-height:200px;margin:30px auto;background:#fff;border-top:7px solid #f5972d;border-left:1px solid #bdbdbd;border-right:1px solid #bdbdbd;box-shadow:0 2px 6px #ccc;position:relative}.content-item .edge-line[data-v-23a5876e]{font-size:0;line-height:0;margin-left:35%;border-top:5px solid #f5972d;border-left:20px solid transparent;box-sizing:border-box}.content-item .wrapper[data-v-23a5876e]{width:100%;padding:30px;box-sizing:border-box}.content-item .no-padding[data-v-23a5876e]{padding:0!important;margin-top:-5px!important}.header[data-v-23a5876e]{width:100%;height:30px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;margin-bottom:35px}.header .item-icon[data-v-23a5876e]{width:30px;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0}.header .title[data-v-23a5876e]{font-size:30px;font-weight:700;color:#f5972d;height:42px;line-height:42px;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0}.header .title[data-v-23a5876e]:before{content:\" \";display:inline-block;width:17.68px;height:17.68px;transform:rotate(45deg);background:#f5972d;margin:3px 7px}.header .line-arrow[data-v-23a5876e]{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.header .line-arrow .line[data-v-23a5876e]{height:1px;width:100px;margin:0 5px;background:#f5972d;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.header .line-arrow .arrow[data-v-23a5876e]{width:32px;height:24px;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;cursor:pointer;background:url(" + __webpack_require__(14) + ")}.content[data-v-23a5876e]{width:100%;margin:0 auto;box-sizing:border-box}", "", {"version":3,"sources":["/./src/components/partial/ContentItem.vue"],"names":[],"mappings":"AACA,wBAAwB,kBAAkB,QAAQ,CACjD,AACD,+BAA+B,aAAa,iBAAiB,iBAAiB,gBAAgB,6BAA6B,8BAA8B,+BAA+B,0BAA0B,iBAAiB,CAClO,AACD,0CAA0C,YAAY,cAAc,gBAAgB,6BAA6B,mCAAmC,qBAAqB,CACxK,AACD,wCAAwC,WAAW,aAAa,qBAAqB,CACpF,AACD,2CAA2C,oBAAqB,yBAA0B,CACzF,AACD,yBAAyB,WAAW,YAAY,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,mBAAmB,kBAAkB,CACrQ,AACD,oCAAoC,WAAW,oBAAoB,YAAY,oBAAoB,aAAa,CAC/G,AACD,gCAAgC,eAAe,gBAAiB,cAAc,YAAY,iBAAiB,oBAAoB,YAAY,oBAAoB,aAAa,CAC3K,AACD,uCAAwC,YAAY,qBAAqB,cAAc,eAAe,wBAAwB,mBAAmB,cAAkB,CAClK,AACD,qCAAqC,oBAAoB,YAAY,oBAAoB,cAAc,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,kBAAkB,CACzS,AACD,2CAA2C,WAAW,YAAY,aAAa,mBAAmB,oBAAoB,YAAY,oBAAoB,aAAa,CAClK,AACD,4CAA4C,WAAW,YAAY,oBAAoB,YAAY,oBAAoB,cAAc,eAAe,wCAA4D,CAC/M,AACD,0BAA0B,WAAW,cAAc,qBAAqB,CACvE","file":"ContentItem.vue","sourcesContent":["\n.blank[data-v-23a5876e]{visibility:hidden;height:0\n}\n.content-item[data-v-23a5876e]{width:1080px;min-height:200px;margin:30px auto;background:#fff;border-top:7px solid #f5972d;border-left:1px solid #bdbdbd;border-right:1px solid #bdbdbd;box-shadow:0 2px 6px #ccc;position:relative\n}\n.content-item .edge-line[data-v-23a5876e]{font-size:0;line-height:0;margin-left:35%;border-top:5px solid #f5972d;border-left:20px solid transparent;box-sizing:border-box\n}\n.content-item .wrapper[data-v-23a5876e]{width:100%;padding:30px;box-sizing:border-box\n}\n.content-item .no-padding[data-v-23a5876e]{padding:0 !important;margin-top:-5px !important\n}\n.header[data-v-23a5876e]{width:100%;height:30px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;margin-bottom:35px\n}\n.header .item-icon[data-v-23a5876e]{width:30px;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0\n}\n.header .title[data-v-23a5876e]{font-size:30px;font-weight:bold;color:#f5972d;height:42px;line-height:42px;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0\n}\n.header .title[data-v-23a5876e]::before{content:' ';display:inline-block;width:17.68px;height:17.68px;transform:rotate(45deg);background:#f5972d;margin:3px 7px 3px\n}\n.header .line-arrow[data-v-23a5876e]{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center\n}\n.header .line-arrow .line[data-v-23a5876e]{height:1px;width:100px;margin:0 5px;background:#f5972d;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1\n}\n.header .line-arrow .arrow[data-v-23a5876e]{width:32px;height:24px;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;cursor:pointer;background:url(../../../static/img/partial/right_arrows.png)\n}\n.content[data-v-23a5876e]{width:100%;margin:0 auto;box-sizing:border-box\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(12);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-23a5876e&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ContentItem.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-23a5876e&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ContentItem.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAMAAACsjQ8GAAAAeFBMVEUAAACtra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra1N9hVJAAAAJ3RSTlMABgr59Ouc0MWlf3FKJRwVD+PLv7eTimUs3drVYT4yW1c3GrCqhUJHseVLAAABH0lEQVQoz2WS27KCMAxFS+V+UUQBRVD0HO3//6E7MzvWjnlaGTLD6k5M6pzrImNMD8gsoAScW6MV5ehThcKg/gBH86ltgn4E7PaACtBOgNJPLBvnNnfAXWABnGJM1H6iQrvfAUZA8gCsgLjxEwX6g4iKcS4wAC7WaNkM/SCiHaAXOAL+AaxGRFc1nsX4TGNWDb/4pMZXwDUGvPiZ6Uztt/EsxlvDYjqBcc+MWW3CdGyixhMzlpIMOHBzHKidHxAn/qIB4Bd8UGc1iYkrtBklo5ySmiWfmTo+cxB4BQI3FZgpwKB0e70KiNcj+Y7aXugFAVkWBfyyCg0vVa9nsO7Z8WBWgUUF6kBgVIFKBcpAIBXIeLTRQTL7LOH37J/B2b8BNk8tU7z0QeYAAAAASUVORK5CYII="

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-item",
	    style: ('margin-top: ' + _vm.contentMarginTop + 'px')
	  }, [_c('div', {
	    staticClass: "edge-line"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "wrapper",
	    class: _vm.noPadding ? 'no-padding' : ''
	  }, [(_vm.title) ? _c('div', {
	    staticClass: "header"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("\n                " + _vm._s(_vm.title) + "\n            ")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_vm._t("default")], 2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "line-arrow"
	  }, [_c('div', {
	    staticClass: "line"
	  })])
	}]}

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _AboutSlider = __webpack_require__(349);
	
	var _AboutSlider2 = _interopRequireDefault(_AboutSlider);
	
	var _ContentItem = __webpack_require__(10);
	
	var _ContentItem2 = _interopRequireDefault(_ContentItem);
	
	var _History = __webpack_require__(350);
	
	var _History2 = _interopRequireDefault(_History);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        ContentItem: _ContentItem2.default,
	        AboutSlider: _AboutSlider2.default,
	        History: _History2.default
	    }
	};

/***/ }),

/***/ 147:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    methods: {
	        showSlider: function showSlider() {
	            var that = this;
	            setTimeout(function () {
	                $('.slider2').fadeOut();
	                $('.slider1').fadeIn();
	                setTimeout(function () {
	                    $('.points-hk').fadeIn();
	                    setTimeout(function () {
	                        $('.title-hk').fadeIn();
	                        setTimeout(function () {
	                            $('.points-asia').fadeIn();
	                            setTimeout(function () {
	                                $('.title-asia').fadeIn();
	                                setTimeout(function () {
	                                    $('.points-global1').fadeIn();
	                                    setTimeout(function () {
	                                        $('.points-global2').fadeIn();
	                                        setTimeout(function () {
	                                            $('.points-global3').fadeIn();
	                                            setTimeout(function () {
	                                                $('.title-global').fadeIn();
	                                                setTimeout(function () {
	                                                    $('.slider1, .points-hk, .title-hk, .points-asia, .title-asia, .points-global1, .points-global2, .points-global3, .title-global').fadeOut();
	                                                    setTimeout(function () {
	                                                        $('.slider2').fadeIn();
	                                                        setTimeout(function () {
	                                                            $('.title-platform').fadeIn();
	                                                            setTimeout(function () {
	                                                                $('.dia').fadeIn();
	                                                                setTimeout(function () {
	                                                                    $('.slider2').fadeOut();
	                                                                    that.showSlider();
	                                                                }, 4000);
	                                                            }, 300);
	                                                        }, 300);
	                                                    }, 400);
	                                                }, 500);
	                                            }, 300);
	                                        }, 500);
	                                    }, 300);
	                                }, 500);
	                            }, 300);
	                        }, 500);
	                    }, 300);
	                }, 500);
	            }, 500);
	        }
	    },
	    created: function created() {
	        var that = this;
	        that.showSlider();
	    }
	};

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ContentItem = __webpack_require__(10);
	
	var _ContentItem2 = _interopRequireDefault(_ContentItem);
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {};
	    },
	
	    computed: {
	        historyPic: function historyPic() {
	            return '../../../static/img/about/' + _vue2.default.config.lang + '.jpg';
	        }
	    },
	    components: {
	        ContentItem: _ContentItem2.default
	    }
	};

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".blank[data-v-1ad2d1f8]{visibility:hidden;height:0}.eg[data-v-1ad2d1f8]{margin-top:30px}.about-eg[data-v-1ad2d1f8]{line-height:25px;color:#616161;font-size:16px;padding:0 35px}.about-eg p[data-v-1ad2d1f8]:last-child{margin-top:10px}", "", {"version":3,"sources":["/./src/components/About.vue"],"names":[],"mappings":"AACA,wBAAwB,kBAAkB,QAAQ,CACjD,AACD,qBAAqB,eAAe,CACnC,AACD,2BAA2B,iBAAiB,cAAc,eAAe,cAAc,CACtF,AACD,wCAAwC,eAAe,CACtD","file":"About.vue","sourcesContent":["\n.blank[data-v-1ad2d1f8]{visibility:hidden;height:0\n}\n.eg[data-v-1ad2d1f8]{margin-top:30px\n}\n.about-eg[data-v-1ad2d1f8]{line-height:25px;color:#616161;font-size:16px;padding:0 35px\n}\n.about-eg p[data-v-1ad2d1f8]:last-child{margin-top:10px\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".blank[data-v-7903b0fd]{visibility:hidden;height:0}.history[data-v-7903b0fd]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.history .marks[data-v-7903b0fd]{display:inline-block;width:950px;height:auto}", "", {"version":3,"sources":["/./src/components/about/History.vue"],"names":[],"mappings":"AACA,wBAAwB,kBAAkB,QAAQ,CACjD,AACD,0BAA0B,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,kBAAkB,CAC5N,AACD,iCAAiC,qBAAqB,YAAY,WAAW,CAC5E","file":"History.vue","sourcesContent":["\n.blank[data-v-7903b0fd]{visibility:hidden;height:0\n}\n.history[data-v-7903b0fd]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center\n}\n.history .marks[data-v-7903b0fd]{display:inline-block;width:950px;height:auto\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".blank[data-v-d9068c92]{visibility:hidden;height:0}.hide-me[data-v-d9068c92]{display:none}.top-slider[data-v-d9068c92]{width:100%;height:432px;overflow:hidden;background:#020109}.top-slider .content-wrapper[data-v-d9068c92]{height:427px;width:1080px;margin:0 auto;background-size:1080px 432px;position:relative}.top-slider .slider1[data-v-d9068c92]{background:url(" + __webpack_require__(318) + ")}.top-slider .slider2[data-v-d9068c92]{background:url(" + __webpack_require__(319) + ")}.points-hk[data-v-d9068c92]{width:30px;height:30px;position:absolute;top:200px;right:450px}.points-hk .point[data-v-d9068c92]{width:5px;height:5px;border-radius:50%;background:#00fff6;position:absolute}.points-hk .point1[data-v-d9068c92]{top:10px;left:5px}.points-hk .point2[data-v-d9068c92]{bottom:2px;right:10px}.points-asia[data-v-d9068c92]{background:url(" + __webpack_require__(323) + ") no-repeat top;background-size:96px 93px;width:96px;height:93px;position:absolute;bottom:127px;right:425px;display:none}.points-global1[data-v-d9068c92]{background:url(" + __webpack_require__(324) + ") no-repeat top;background-size:641px 277px;width:641px;height:277px;position:absolute;bottom:87px;right:374px;display:none}.points-global2[data-v-d9068c92]{background:url(" + __webpack_require__(325) + ") no-repeat top;background-size:703px 314px;width:703px;height:314px;position:absolute;bottom:52px;right:318px;display:none}.points-global3[data-v-d9068c92]{background:url(" + __webpack_require__(326) + ") no-repeat top;background-size:699px 340px;width:699px;height:340px;position:absolute;bottom:25px;right:322px}.title[data-v-d9068c92]{color:#fff;font-size:39px;position:absolute;left:826px}.title-hk[data-v-d9068c92]{top:135px}.title-asia[data-v-d9068c92]{top:208px}.title-global[data-v-d9068c92]{top:278px}.title-platform[data-v-d9068c92]{top:130px;right:72px;left:auto}.dia[data-v-d9068c92]{position:absolute;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;font-size:25px;font-weight:700}.dia1[data-v-d9068c92]{background-size:140px 140px;width:140px;height:140px;background:url(" + __webpack_require__(320) + ") no-repeat 50%;left:555px;top:200px}.dia2[data-v-d9068c92]{background-size:150px 150px;width:150px;height:150px;background:url(" + __webpack_require__(321) + ") no-repeat 50%;right:239px;top:206px}.dia3[data-v-d9068c92]{background-size:125px 125px;width:125px;height:125px;background:url(" + __webpack_require__(322) + ") no-repeat 50%;right:127px;top:200px}", "", {"version":3,"sources":["/./src/components/about/AboutSlider.vue"],"names":[],"mappings":"AACA,wBAAwB,kBAAkB,QAAQ,CACjD,AACD,0BAA0B,YAAY,CACrC,AACD,6BAA6B,WAAW,aAAa,gBAAgB,kBAAkB,CACtF,AACD,8CAA8C,aAAa,aAAa,cAAc,6BAA6B,iBAAiB,CACnI,AACD,sCAAsC,wCAA8D,CACnG,AACD,sCAAsC,wCAA8D,CACnG,AACD,4BAA4B,WAAW,YAAY,kBAAkB,UAAU,WAAW,CACzF,AACD,mCAAmC,UAAU,WAAW,kBAAkB,mBAAmB,iBAAiB,CAC7G,AACD,oCAAoC,SAAS,QAAQ,CACpD,AACD,oCAAoC,WAAW,UAAU,CACxD,AACD,8BAA8B,uDAA+E,0BAA0B,WAAW,YAAY,kBAAkB,aAAa,YAAY,YAAY,CACpN,AACD,iCAAiC,uDAAkF,4BAA4B,YAAY,aAAa,kBAAkB,YAAY,YAAY,YAAY,CAC7N,AACD,iCAAiC,uDAAkF,4BAA4B,YAAY,aAAa,kBAAkB,YAAY,YAAY,YAAY,CAC7N,AACD,iCAAiC,uDAAkF,4BAA4B,YAAY,aAAa,kBAAkB,YAAY,WAAW,CAChN,AACD,wBAAwB,WAAW,eAAe,kBAAkB,UAAU,CAC7E,AACD,2BAA2B,SAAS,CACnC,AACD,6BAA6B,SAAS,CACrC,AACD,+BAA+B,SAAS,CACvC,AACD,iCAAiC,UAAU,WAAW,SAAS,CAC9D,AACD,sBAAsB,kBAAkB,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,mBAAmB,eAAe,eAAgB,CAC1Q,AACD,uBAAuB,4BAA4B,YAAY,aAAa,uDAA2E,WAAW,SAAS,CAC1K,AACD,uBAAuB,4BAA4B,YAAY,aAAa,uDAA2E,YAAY,SAAS,CAC3K,AACD,uBAAuB,4BAA4B,YAAY,aAAa,uDAA2E,YAAY,SAAS,CAC3K","file":"AboutSlider.vue","sourcesContent":["\n.blank[data-v-d9068c92]{visibility:hidden;height:0\n}\n.hide-me[data-v-d9068c92]{display:none\n}\n.top-slider[data-v-d9068c92]{width:100%;height:432px;overflow:hidden;background:#020109\n}\n.top-slider .content-wrapper[data-v-d9068c92]{height:427px;width:1080px;margin:0 auto;background-size:1080px 432px;position:relative\n}\n.top-slider .slider1[data-v-d9068c92]{background:url(../../../static/img/about/about_slider1_bg.jpg)\n}\n.top-slider .slider2[data-v-d9068c92]{background:url(../../../static/img/about/about_slider2_bg.jpg)\n}\n.points-hk[data-v-d9068c92]{width:30px;height:30px;position:absolute;top:200px;right:450px\n}\n.points-hk .point[data-v-d9068c92]{width:5px;height:5px;border-radius:50%;background:#00fff6;position:absolute\n}\n.points-hk .point1[data-v-d9068c92]{top:10px;left:5px\n}\n.points-hk .point2[data-v-d9068c92]{bottom:2px;right:10px\n}\n.points-asia[data-v-d9068c92]{background:url(../../../static/img/about/points_aisa.png) no-repeat top center;background-size:96px 93px;width:96px;height:93px;position:absolute;bottom:127px;right:425px;display:none\n}\n.points-global1[data-v-d9068c92]{background:url(../../../static/img/about/points_global1.png) no-repeat top center;background-size:641px 277px;width:641px;height:277px;position:absolute;bottom:87px;right:374px;display:none\n}\n.points-global2[data-v-d9068c92]{background:url(../../../static/img/about/points_global2.png) no-repeat top center;background-size:703px 314px;width:703px;height:314px;position:absolute;bottom:52px;right:318px;display:none\n}\n.points-global3[data-v-d9068c92]{background:url(../../../static/img/about/points_global3.png) no-repeat top center;background-size:699px 340px;width:699px;height:340px;position:absolute;bottom:25px;right:322px\n}\n.title[data-v-d9068c92]{color:#fff;font-size:39px;position:absolute;left:826px\n}\n.title-hk[data-v-d9068c92]{top:135px\n}\n.title-asia[data-v-d9068c92]{top:208px\n}\n.title-global[data-v-d9068c92]{top:278px\n}\n.title-platform[data-v-d9068c92]{top:130px;right:72px;left:auto\n}\n.dia[data-v-d9068c92]{position:absolute;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;font-size:25px;font-weight:bold\n}\n.dia1[data-v-d9068c92]{background-size:140px 140px;width:140px;height:140px;background:url(../../../static/img/about/dia1.png) no-repeat center center;left:555px;top:200px\n}\n.dia2[data-v-d9068c92]{background-size:150px 150px;width:150px;height:150px;background:url(../../../static/img/about/dia2.png) no-repeat center center;right:239px;top:206px\n}\n.dia3[data-v-d9068c92]{background-size:125px 125px;width:125px;height:125px;background:url(../../../static/img/about/dia3.png) no-repeat center center;right:127px;top:200px\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(241);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1ad2d1f8&scoped=true!../../node_modules/sass-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./About.vue", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1ad2d1f8&scoped=true!../../node_modules/sass-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./About.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(255);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-7903b0fd&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./History.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-7903b0fd&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./History.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(263);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-d9068c92&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AboutSlider.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-d9068c92&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AboutSlider.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/about_slider1_bg.62e8e52.jpg";

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/about_slider2_bg.5b6b913.jpg";

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dia1.26221b0.png";

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dia2.c9c859e.png";

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dia3.ed521ce.png";

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAoEAAAEVBAMAAABtYiJDAAAAJFBMVEUAAAAA//YA//YA//YA//YA//YA//YA//YA//YA//YA//YA//b3HUm8AAAAC3RSTlMADFDx3smaaiu1FH/xK+AAAAT8SURBVHja7Ju9LkVBFIXndKIyGlqF3weQiJYodCIaHZFoiUSLwgPwAuIVUM3LIRdLMzcnM86x9uz1tTcSd929Z6+9zpzASBfngqigu7tek4Q1PJ/tHG0EUUy3vp1eHlSE5cycppQ2b4IoZf44pfS2FEQpC/sppdeLIKRgb9TFZGiSyM38O3LU2uoGJ0YlC1Usrl7eBlHO7Mrh7slTEMXMP6a0JbtXwf12Si/nQZTSLacPDjQriumu0gd7XAqamv6MCtpyoIxdbGwL4psk1jZxPjdjLQ3ic9SjJpIxNrjV9UjFyVbaGAMV0xVsvAGtdTHfELA2SfiMiDE3w2iGbTlqxoXM1lbXrILTkgV1MReNTpLedSo38/9nZaOOunheozrtrrSV1HtGVCfkNLXSVlG/t6A6bcbdYOB5gd05X502424w7LxAfpOvTptxNxh2XkDBfHXajLvBsPMCOuW11QXcaSWET/IK6hJ473mR/xsoaDauHzDvxwmZr07I6ddfQ8H+UxrVCTn97ngoof5OEdUJOf3mDCih3ocYqhNyOs66UEK9DzFUJ+T0nLeihIoOsYmcrWf+MdangDjEHD41gYGoyPpwiPl7ajLpPZKHRtSTJMZpvUfy4JLZzUx6NfuzkyhI7Kjxr2V6j6OLibc6tEemclge/dImC/h2GQV1ka2sw/AJ01RnBJWWqU6iC72cQMFM7/FcKiflu1e99d6fTxJ3vffnbsZd7wXC7dcv6lXNSfEbplu0ntHFOjNvvbSKLtYZevuvUdxfrCN8C9qb4/tSUFsHTRf723x/JoletydxM9SP+wGvo7Z55YRpqzN67YkoWXCp4CfqYh4cTpIJcjM0UallR00SlRre6liiUrPJwtdy0dR3GhEsuG311XggZGnrbB8PBH2N+YvRgILyuLVdrD3rnZ07uIEYhKEo2H/Xqy3B+MBTmOkgRMTfFmFbSfT62zRjBZeJ2rRk29WZliwnC5+bliRI1C9PSypMFgAAAAAAAAAAcJjEgaYIh+qe/g02weFi1wEccSVFhxW0i69TSaSZExJ1yr+r01svn77xFl7mS6AazUlEKVK5znDICubYxSrJddKMRH2drq7QWwOE+KqprFPSXYsOQ5c7Z9KSYtpnBcfs4hqVRJo5IVGn6OpMFgAAAAAA4NeuGdsoFMRAdDe7EC65Fu6ugEsuJSMnIUQUQESKKIESaAGIfnN8CaGNEFobibH8XgXI/FmP7QF2/tydBOD2yf29HzIgUpBDIgvXCRWUAxXTSd4ObqabOp3gqD3U/fZ7wlTn4LieLX7ZLNipP//D6UDrtfOxGobhb1fAyudyrOCF3mvnaz5W8LwpiRnNCBV0mxFU7DUjdBK3GcHN2K5o7RNyf8RJaPOW4RmzP6R+VIacNvMbWqm9mfupRYTb3gkz4t19Ykbc+3fMiPcGlNmMvKaCic3Ii1XczAifoOuKVqcUkCvaM8ilycAVjXwuAKBl+okAeBp8tQ0SkjKQ0iUp3gkVlAMVa3aSVEvG5maKTHwpFs1RF5n4UjDaVFdU4kvRuG8WyFLLQPCBLHUnVFAOVEwnMYCb0SKZo77BVKdFqs0CAAAAAACACmQx5a52yQiexRQQUOwspoKAQmcxFQQUO8WlIKDYSUIFAYWuoISAJH5E7L9fQQixK6jwGMcWkIIhCC4gBVMaXEACg1FKAWkQWUAiPBDQFbElZAxcY+m6AAAAAElFTkSuQmCC"

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/points_global3.cd2a85e.png";

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(290)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(140),
	  /* template */
	  __webpack_require__(368),
	  /* scopeId */
	  "data-v-1ad2d1f8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(315)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(147),
	  /* template */
	  __webpack_require__(393),
	  /* scopeId */
	  "data-v-d9068c92",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(307)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(148),
	  /* template */
	  __webpack_require__(385),
	  /* scopeId */
	  "data-v-7903b0fd",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 368:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('about-slider'), _vm._v(" "), _c('div', {
	    staticClass: "eg"
	  }, [_c('content-item', {
	    attrs: {
	      "title": _vm.$t('about')
	    }
	  }, [_c('div', {
	    staticClass: "about-eg"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('aboutEgP1')))])])])], 1), _vm._v(" "), _c('history')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 385:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('content-item', {
	    attrs: {
	      "title": _vm.$t('history')
	    }
	  }, [_c('div', {
	    staticClass: "history"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.historyPic
	    }
	  })])])], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "top-slider"
	  }, [_c('div', {
	    staticClass: "content-wrapper slider1 hide-me"
	  }, [_c('div', {
	    staticClass: "animated fadeIn points-hk hide-me"
	  }, [_c('div', {
	    staticClass: "point point1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "point point2"
	  })]), _vm._v(" "), _c('h1', {
	    staticClass: "title title-hk hide-me"
	  }, [_vm._v("始于港澳台")]), _vm._v(" "), _c('div', {
	    staticClass: "points-asia hide-me"
	  }), _vm._v(" "), _c('h1', {
	    staticClass: "title title-asia hide-me"
	  }, [_vm._v("精于东南亚")]), _vm._v(" "), _c('div', {
	    staticClass: "points-global1 hide-me"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "points-global2 hide-me"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "points-global3 hide-me"
	  }), _vm._v(" "), _c('h1', {
	    staticClass: "title title-global hide-me"
	  }, [_vm._v("成于全球")])]), _vm._v(" "), _c('div', {
	    staticClass: "content-wrapper slider2 hide-me"
	  }, [_c('div', {
	    staticClass: "title title-platform hide-me"
	  }, [_vm._v("打造全球顶尖游戏发行平台")]), _vm._v(" "), _c('div', {
	    staticClass: "dia dia1 faa-pulse animated"
	  }, [_vm._v("精品")]), _vm._v(" "), _c('div', {
	    staticClass: "dia dia2 faa-pulse animated"
	  }, [_vm._v("快速")]), _vm._v(" "), _c('div', {
	    staticClass: "dia dia3 faa-pulse animated"
	  }, [_vm._v("专业")])])])
	}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.d377199d2017794ebfeb.js